import React from 'react';
import { FadeIn } from './FadeIn';
import { Button } from './Button';
interface CTASectionProps {
  title: string;
  subtitle?: string;
  buttonText: string;
  buttonVariant?: 'primary' | 'secondary' | 'outline';
  onNavigate: (page: string) => void;
  page: string;
  variant?: 'light' | 'dark';
}
export function CTASection({
  title,
  subtitle,
  buttonText,
  buttonVariant = 'primary',
  onNavigate,
  page,
  variant = 'dark'
}: CTASectionProps) {
  const isDark = variant === 'dark';
  return <section className={`py-24 text-center px-4 ${isDark ? 'bg-navy' : 'bg-white'}`} data-id="element-29">
      <FadeIn className="max-w-3xl mx-auto" data-id="element-30">
        <h2 className={`text-3xl md:text-4xl font-extrabold mb-6 leading-tight ${isDark ? 'text-white' : 'text-navy'}`} data-id="element-31">
          {title}
        </h2>
        {subtitle && <p className={`text-lg mb-8 ${isDark ? 'text-gray-300' : 'text-gray-600'}`} data-id="element-32">
            {subtitle}
          </p>}
        <Button variant={isDark ? 'primary' : buttonVariant} size="lg" onClick={() => onNavigate(page)} data-id="element-33">
          {buttonText}
        </Button>
      </FadeIn>
    </section>;
}